// @ts-nocheck
import { defineComponent, h } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
export default defineComponent({
  name: 'NodeContent',
  props: {
    node: {
      type: Object,
      required: true,
    },
    panel: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const ns = useNamespace('cascader-node')
    return {
      ns,
    }
  },
  render() {
    const { ns } = this
    const { node, panel } = this.$props
    const { data, label } = node
    const { renderLabelFn } = panel
    return h(
      'span',
      {
        class: ns.e('label'),
        title: label,
      },
      renderLabelFn ? renderLabelFn({ node, data }) : label
    )
  },
})
